import {CubeTransparentIcon} from "@heroicons/react/24/outline";
import {Link} from "react-router-dom";

interface ModuleDisabledPageProps {
    moduleName?: string;
}

export default function ModuleDisabledPage({moduleName}: ModuleDisabledPageProps) {
    return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
            <div className="p-4 rounded-2xl bg-gray-100 mb-6">
                <CubeTransparentIcon className="w-12 h-12 text-gray-400"/>
            </div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
                {moduleName ? `Le module ${moduleName} n'est pas activé` : "Ce module n'est pas activé"}
            </h2>
            <p className="text-sm text-gray-500 mb-6 max-w-md">
                Contactez votre administrateur ou rendez-vous sur la page des modules pour en savoir plus.
            </p>
            <Link
                to="/modules"
                className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 transition-colors"
            >
                Voir les modules
            </Link>
        </div>
    );
}
